import { useEffect, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { OAuth2 } from '../../services/McDataServices'
import { getUserDetailsAndProcess } from '../../services/DataServiceMethods'
import { useGlobalStoreActions, useGlobalStoreData } from '../../store/globalStore'
import { useToast } from './useToast'

export const useGmailOAuth = (t) => {
  const location = useLocation()
  const navigate = useNavigate()

  const { showSuccess, showError } = useToast()

  const { setUserData } = useGlobalStoreActions()
  const user = useGlobalStoreData.user()

  const params = useMemo(() => new URLSearchParams(location.search), [location.search])

  const code = useMemo(() => params.get('code'), [params])
  const state = useMemo(() => params.get('state'), [params])

  useEffect(() => {
    if (!code || !state) return

    const handleOAuthCallback = async () => {
      const provider = sessionStorage.getItem('oauth_provider') || 'gmail'
      const isOutlook = provider === 'outlook'

      try {
        const callbackFn = isOutlook ? OAuth2.OutlookCallback : OAuth2.GmailCallback
        const successKey = isOutlook ? 'outlook.success' : 'gmail.success'
        const errorKey = isOutlook ? 'outlook.error' : 'gmail.error'

        const response = await callbackFn({ code, state })

        if (response) {
          getUserDetailsAndProcess(true, user, setUserData, true)
          showSuccess(t(successKey))
        } else {
          showError(t(errorKey))
        }
      } catch (err) {
        const errorKey = isOutlook ? 'outlook.error' : 'gmail.error'
        showError(t(errorKey))
      } finally {
        sessionStorage.removeItem('oauth_provider')
        const currentPath = location.pathname
        navigate(currentPath, { replace: true })
      }
    }

    handleOAuthCallback()
  }, [code, state, showSuccess, showError, t, navigate, location.pathname, user, setUserData])

  return { code, state }
}
